import { Component, OnInit } from '@angular/core';
import { DynamicDialogConfig } from 'primeng/dynamicdialog';

@Component({
  selector: 'app-billet-generate-result-dialog',
  templateUrl: './billet-generate-result-dialog.component.html',
  styleUrls: ['./billet-generate-result-dialog.component.scss'],
})
export class BilletGenerateResultDialogComponent implements OnInit {
  payload: Record<string, unknown>;
  rawJsonFallback: string;
  steps: Array<Record<string, unknown>> = [];
  invoices: Array<Record<string, unknown>> = [];
  summary: unknown;
  error: Record<string, unknown> | null = null;

  constructor(public config: DynamicDialogConfig) {}

  ngOnInit(): void {
    const data = this.config.data;
    if (data && typeof data === 'object' && !Array.isArray(data)) {
      this.payload = data as Record<string, unknown>;
      this.steps = Array.isArray(this.payload['steps'])
        ? (this.payload['steps'] as Array<Record<string, unknown>>)
        : [];
      this.invoices = Array.isArray(this.payload['invoices'])
        ? (this.payload['invoices'] as Array<Record<string, unknown>>)
        : [];
      this.summary = this.payload['summary'];
      const err = this.payload['error'];
      this.error = err && typeof err === 'object' ? (err as Record<string, unknown>) : null;
      this.rawJsonFallback = '';
    } else {
      this.payload = {};
      this.rawJsonFallback = JSON.stringify(data, null, 2);
    }
  }

  asJson(value: unknown): string {
    try {
      return JSON.stringify(value, null, 2);
    } catch {
      return String(value);
    }
  }

  decisionLabel(decision: unknown): string {
    switch (decision) {
      case 'created':
        return 'Criado';
      case 'skipped':
        return 'Pulado';
      case 'removed_balcao':
        return 'Balcão (removido)';
      default:
        return decision ? String(decision) : '';
    }
  }
}
